import { TITLEBAR_ELEMENT_ID } from '@repo/studio-desktop-bridge/window-chrome'
import { AIDA_FLOATING_PANEL_INSET_PX } from './constants/presentation'
import type { ViewportSize } from './clamp-floating-position'

export function queryStudioTitlebar() {
  if (typeof document === 'undefined') {
    return null
  }
  return document.querySelector(`#${CSS.escape(TITLEBAR_ELEMENT_ID)}`)
}

export function readFloatingPanelSafeTop() {
  const titlebar = queryStudioTitlebar()
  if (!titlebar) {
    return AIDA_FLOATING_PANEL_INSET_PX
  }
  return titlebar.getBoundingClientRect().bottom + AIDA_FLOATING_PANEL_INSET_PX
}

export function readFloatingPanelViewport(): ViewportSize {
  if (typeof window === 'undefined') {
    return {
      width: 1200,
      height: 800,
      safeTop: AIDA_FLOATING_PANEL_INSET_PX,
    }
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    safeTop: readFloatingPanelSafeTop(),
  }
}
